import RelationTag from './RelationTag'
export default RelationTag
